export default __webpack_public_path__ + "static/media/Workflow.6b5303df.svg";